export default __webpack_public_path__ + "static/media/Ballroll_00213.ddf4f0df.png";